/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_Class_Body_HintInputs */

const en_reading_class_body_hint = /** @type {(inputs: Reading_Class_Body_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The paragraphs of the document`)
};

const es_reading_class_body_hint = /** @type {(inputs: Reading_Class_Body_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los párrafos del documento`)
};

/**
* | output |
* | --- |
* | "The paragraphs of the document" |
*
* @param {Reading_Class_Body_HintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reading_class_body_hint = /** @type {((inputs?: Reading_Class_Body_HintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_Class_Body_HintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_reading_class_body_hint(inputs)
	return en_reading_class_body_hint(inputs)
});